/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Savebasicinformation2Inputs */

const en_savebasicinformation2 = /** @type {(inputs: Savebasicinformation2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Basic Information`)
};

const de_savebasicinformation2 = /** @type {(inputs: Savebasicinformation2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grundlegende Informationen speichern`)
};

/**
* | output |
* | --- |
* | "Save Basic Information" |
*
* @param {Savebasicinformation2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const savebasicinformation2 = /** @type {((inputs?: Savebasicinformation2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Savebasicinformation2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_savebasicinformation2(inputs)
	return de_savebasicinformation2(inputs)
});
export { savebasicinformation2 as "saveBasicInformation" }